// Plan, "Our plan" subtab (redesign slice 5b; wireframes 2, 3 and 14).
// The week header and menu sit on top; below it either the week overview,
// one day (?day=Saturday, so the browser's Back returns to the week), or
// for a week with nothing planned, the three ways to start. On a wide
// screen the overview is the seven-column week with its picker panel
// (slice 5d, wireframe 24).
//
// Replaces the old single long page (week controls, quick add, seven
// editable day cards, lists, other weeks). Its parts now live in the week
// menu (WeekHeader), the day view and the overview.
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useMealPlanner } from "../hooks/MealPlannerContext";
import { WeekHeader } from "../components/plan/WeekHeader";
import { WeekOverview } from "../components/plan/WeekOverview";
import { DesktopWeek } from "../components/plan/DesktopWeek";
import { useIsMobile } from "../hooks/useIsMobile";
import { DayView } from "../components/plan/DayView";
import { EmptyWeek } from "../components/plan/EmptyWeek";
import { PlanPrint } from "../components/plan/PlanPrint";
import { DAYS, WIDE_PLAN_MIN_WIDTH } from "../lib/constants";
import { weekMealCount } from "../lib/planUtils";
import type { Day } from "../lib/types";

export function PlanPage() {
  const mp = useMealPlanner();
  const wide = !useIsMobile(WIDE_PLAN_MIN_WIDTH - 1);
  const [params, setParams] = useSearchParams();
  // Weeks someone chose to start blank, so the overview shows even though
  // nothing is planned yet. Session only.
  const [blankWeeks, setBlankWeeks] = useState<Set<string>>(new Set());
  const dayParam = params.get("day");
  const day = dayParam && (DAYS as readonly string[]).includes(dayParam) ? (dayParam as Day) : null;
  const openDay = (d: Day) => setParams({ day: d });
  const backToWeek = () => setParams({}, { replace: false });

  const empty = weekMealCount(mp.weekData) === 0 && !blankWeeks.has(mp.weekStart);

  const showWeek = !day && !empty;
  return (
    <div style={{ maxWidth: wide && showWeek ? undefined : 720 }}>
      {!day && (
        <div style={{ maxWidth: 720 }}>
          <WeekHeader />
        </div>
      )}
      {day ? (
        <DayView day={day} onBack={backToWeek} />
      ) : empty ? (
        <EmptyWeek onStartBlank={() => setBlankWeeks((s) => new Set(s).add(mp.weekStart))} />
      ) : (
        wide ? <DesktopWeek key={mp.weekStart} onOpenDay={openDay} /> : <WeekOverview onOpenDay={openDay} />
      )}
      <PlanPrint />
    </div>
  );
}
